module.exports = __webpack_public_path__ + "img/hic-cardiovascular-diseases-male.4681b0da.png";